(function () {
    'use strict';

    function myProfileDataService($http, $q) {
        var baseUrl = '[BuildifyApiHost]/api/myprofile';
        var svc = this;
        svc.myProfileData = null;

        function loadMyProfile() {
            if (svc.myProfileData) {
                return $q.when(svc.myProfileData);
            }

            return $http.get(baseUrl).then(function (response) {
                svc.myProfileData = response.data;
                return svc.myProfileData;
            });
       };   

       function loadEntityProfile(entityId) {
           return $http.get(baseUrl + '/' + entityId).then(function (response) {
               return response.data;
           });
       };

       function updateMyProfile(profile) {
           return $http.put(baseUrl, profile).then(function (response) {
               svc.myProfileData = null;
               return response.data;
           });
       };

       function updateEntityProfile(entityId, profile) {
            return $http.put(baseUrl + '/' + entityId, profile).then(function (response) {
                return response.data;
            });
        };

       function updateMilestones(milestones) {
           return $http.post(baseUrl + '/milestones', milestones).then(function (response) {
               svc.myProfileData = null;
               return response.data;
           });
       }

        return {
            loadMyProfile: loadMyProfile,
            loadEntityProfile: loadEntityProfile,
            updateMyProfile: updateMyProfile,
            updateEntityProfile: updateEntityProfile,
            updateMilestones: updateMilestones
        }
    }

    myProfileDataService.$inject = ['$http', '$q'];

    angular.module('ecap.common').service('myProfileDataService', myProfileDataService);
})();
